import { Checkbox, ICheckboxProps, UIText2 } from '@cian/ui-kit';
import { forwardRef } from 'react';
import styles from './CustomCheckbox.css';

interface ICustomCheckboxProps extends ICheckboxProps {
  rightAdornment?: React.ReactNode;
  caption?: string;
}

export const CustomCheckbox = forwardRef<HTMLLabelElement, ICustomCheckboxProps>(function CustomCheckbox(
  { caption, rightAdornment, ...checkboxProps },
  ref,
) {
  return (
    <div data-testid="custom-checkbox" className={styles['container']}>
      <div className={styles['checkbox']}>
        <Checkbox {...checkboxProps} ref={ref} />
      </div>
      {rightAdornment && <div className={styles['right-adornment']}>{rightAdornment}</div>}
      {caption && (
        <div className={styles['caption']}>
          <UIText2 color="text-secondary-default">{caption}</UIText2>
        </div>
      )}
    </div>
  );
});
